<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M54.638 67.006L46.4855 75.1585C40.5976 81.0464 31.0514 81.0464 25.1635 75.1585V75.1585C19.2756 69.2706 19.2756 59.7244 25.1635 53.8365L33.316 45.684" stroke="black" stroke-width="4"/>
<path d="M66.5085 55.1355L74.661 46.983C80.5489 41.0951 80.5489 31.5489 74.661 25.661V25.661C68.7731 19.7731 59.2269 19.7731 53.339 25.661L45.1865 33.8135" stroke="black" stroke-width="4"/>
<path d="M64.7615 35.5604L35.063 65.2589" stroke="black" stroke-width="4"/>
</svg>

</template>
